<template>
  <div class="footer">
    <slot></slot>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  //这里存放数据
  data () {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.footer {
  padding: 10px 10px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background:white;
  border-top: 1px solid #eff1f4;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue